import React, { FC, ReactElement } from "react";

import { Grid, Typography } from "@mui/material";

import { FileUploader } from "react-drag-drop-files";

import { useAppSelector } from "../hooks/reduxhook";
import { getType } from "../redux/slices/typeSlice";
import { COLLECTION } from "../data/constants";

interface i_value {
  base64: string;
  name: string;
  filetype: string;
}

interface IFileUpload {
  setFile: any;
  content: "string";
  file: i_value;
  fileTypes: [];
}

const FileUpload: FC<any> = ({
  setFile,
  content,
  file,
  fileTypes,
}: IFileUpload): ReactElement => {
  const handleChange = (file: FileList) => {
    setFile(file);
  };

  const chatType = useAppSelector(getType);

  return (
    <FileUploader
      multiple={true}
      handleChange={handleChange}
      name="file"
      types={chatType?.type === COLLECTION ? fileTypes : chatType?.uploadtypes}
      style={{ height: "2000px" }}
    >
      <>
        <Grid
          px={10}
          py={10}
          justifyContent="center"
          alignItems="center"
          container
          direction="column"
          sx={{
            background: "rgba(217,217,217,.37)",
            borderRadius: 2,
            cursor: "pointer",
          }}
        >
          {/* <InsertDriveFileIcon color="secondary" /> */}
          <Typography
            style={{ fontWeight: "bold" }}
            textAlign="center"
            mt={2}
            color="primary"
          >
            {file ? `File name: ${file?.name}.${file?.filetype}` : content}
          </Typography>
        </Grid>
      </>
    </FileUploader>
  );
};

export default FileUpload;
